import { FC } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setSnackbarMessage } from 'store/ui/uiSlice';
import { selectSnackbarMessage } from 'store/ui/uiSelectors';
// Components
import { Button } from './Buttons';
// Icons
import { MdClose } from 'react-icons/md';

const Snackbar:FC = () => {
  const dispatch = useAppDispatch();
  
  const snackbarMessage = useAppSelector(selectSnackbarMessage);

  const handleClick = () => {
    dispatch(setSnackbarMessage(null));
  }

  if ( !snackbarMessage ) return null;
  return (
    <div
      className="
        fixed right-0 bottom-0
        flex items-center gap-4
        bg-red-500
        rounded
        m-2 px-4 py-2
        z-50
      "
      style={{
        maxWidth: 400
      }}
    >
      <span className="text-white text-sm font-semibold">{snackbarMessage}</span>
      <Button
        className="px-2"
        onClick={handleClick}
        size="small"
      ><MdClose /></Button>
    </div>
  )
}

export default Snackbar;
